import { Route, Switch, useRouteMatch } from "react-router-dom";

import CollectionItemDetail from "../../components/collection-item-detail";
import CollectionPage from "../../pages/collection";

const CollectionRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/product`}>
        <CollectionItemDetail />
      </Route>
      <Route exact path={path}>
        <CollectionPage />
      </Route>
    </Switch>
  );
};

export default CollectionRoutes;
